import { SxStyle } from '../../types/style';

const contentStack: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center',
    height: { xs: 'fitContent', md: '100vh' }
};

const contentStackBox: SxStyle = {
    width: '80%'
}

const contentStackBoxTypography: SxStyle = {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: '700',
    fontSize: '32px',
    textAlign: 'center'
}

export const loginStyle = {
    contentStack,
    contentStackBox,
    contentStackBoxTypography,
};